import create, { SetState, StateCreator, StoreApi } from "zustand";

interface MemberDetailsStore {
  memberData: any;
  setMemberData: (x: any) => void;
  dataCardId?: number;
  setDataCardId: (x: number) => void;
  clearStore: () => void;
  memberDetailLoader: any;
  setMemberDetailLoader: (x: any) => void;
  chronicsList: any;
  setChronicsList: (x: any) => void;
  refreshClaimData: any;
  setRefreshClaimData: (x: any) => void;
  measuresData: any;
  setMeasuresData: (x: any) => void;
}

let store: StateCreator<MemberDetailsStore, [], [], MemberDetailsStore> | StoreApi<MemberDetailsStore> = (set: SetState<MemberDetailsStore>) => ({
  memberData: null,
  setMemberData: (x) => {
    set(() => ({ memberData: x }));
  },
  dataCardId: undefined,
  setDataCardId: (dataCardId) => {
    set(() => ({ dataCardId }));
  },
  memberDetailLoader: false,
  setMemberDetailLoader: (x) => {
    set(() => ({ memberDetailLoader: x }));
  },
  chronicsList: [],
  setChronicsList: (x) => {
    set(() => ({ chronicsList: x }));
  },
  refreshClaimData: [],
  setRefreshClaimData: (x) => {
    set(() => ({ refreshClaimData: x }));
  },
  measuresData: [],
  setMeasuresData: (x) => {
    set(() => ({ measuresData: x }));
  },
  clearStore: () => {
    set(() => ({ memberData: null, dataCardId: undefined, memberDetailLoader: false, chronicsList: [], refreshClaimData: [], measuresData: [] }));
  },
});

export const useMemberDetailsStore = create(store);
